export default "/form/@formId/@recordId";
